<template>
    <div class="p-6">
      <h1 class="text-3xl font-bold text-gray-900 dark:text-gray-50 mb-6 flex items-center">
        <button
          @click="$router.push('/updatequeue')"
          class="mr-4 bg-blue-600 text-white px-4 py-1.5 rounded-md hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 transition duration-200 text-sm font-medium flex items-center"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            class="h-4 w-4 mr-1"
            viewBox="0 0 20 20"
            fill="currentColor"
          >
            <path
              fill-rule="evenodd"
              d="M9.707 16.707a1 1 0 01-1.414 0l-6-6a1 1 0 010-1.414l6-6a1 1 0 011.414 1.414L5.414 9H17a1 1 0 110 2H5.414l4.293 4.293a1 1 0 010 1.414z"
              clip-rule="evenodd"
            />
          </svg>
          Back to Update Queues
        </button>
        {{ isNewUpdateQueue ? "Add Update Queue" : "View Update Queue" }}
      </h1>
  
      <div v-if="loading" class="text-center py-4">
        <p class="text-gray-600">Loading...</p>
      </div>
  
      <div
        v-else-if="error"
        class="bg-red-100 border border-red-400 text-red-700 px-4 py-3 rounded relative"
        role="alert"
      >
        <strong class="font-bold">Error!</strong>
        <span class="block sm:inline">{{ error }}</span>
      </div>
  
      <form v-else @submit.prevent="saveStatus" class="space-y-6 p-6 glass-card">
        <div class="grid grid-cols-1 md:grid-cols-2 gap-6">
          <div>
            <label
              for="status"
              class="block text-sm font-medium text-gray-700 dark:text-white"
              >Status</label
            >
            <input
              v-model="formatStatus" 
              type="text"
              readonly
              class="w-full border border-gray-300 rounded px-3 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500"
            >
          </div>

          <div>
            <label
              for="agent"
              class="block text-sm font-medium text-gray-700 dark:text-white"
              >Agent</label
            >
            <input
              v-model="formField.agent" 
              type="text"
              readonly
              class="w-full border border-gray-300 rounded px-3 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500"
            >
          </div>

          <div>
            <label
              for="error_message"
              class="block text-sm font-medium text-gray-700 dark:text-white"
              >Error Message</label
            >
            <textarea
              type="textarea"
              id="error_message"
              v-model="formField.error_message"             
              readonly
              class="w-full border border-gray-300 rounded px-3 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500"
            ></textarea>
          </div>
        </div>

        <div class="flex justify-end space-x-3">
          <button
            type="button"
            @click="$router.push({ name: 'UpdateQueueView' })"
            class="px-4 py-2 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-indigo-600 hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
          >
            Back
          </button>
        </div>
      </form>
    </div>
  </template>
  
  <script>
  import { getUpdateQueueById} from "@/services/updateQueueService";
  import { useStore } from "@/store";
  
  export default {
    name: "OrganizationDetails",
    data() {
      return {
        formField: {
          status: "",
          agent: "",
          error_message: null,
        },
        loading: false,
        error: null,
        fieldErrors: {},
        isNewUpdateQueue: false,
        agents: [],
        statuses : [
          { key:'queued', label: 'Queued'},
          { key:'in_progress', label: 'In Progress'},
          { key:'completed', label: 'Completed'},
          { key:'failed', label: 'Failed'},
        ]
      };
    },
    computed: {
      user() {
        return useStore.getUser();
      }, 
      formattedUpdatedQueue() {
        return {
          ...this.formField
        };
      },
      formatStatus(){
        return this.statuses.find((item) => item.key === this.formField.status).label;
      }
    },
    async created() {
      const updatequeueId = this.$route.params.id;
      this.fetchUpdateQueue(updatequeueId);
    },
    methods: {
      async fetchUpdateQueue(updatequeueId) {
        this.loading = true;
        this.error = null;
        try {
          this.formField = await getUpdateQueueById(updatequeueId);
        } catch (error) {
          console.error("Error fetching update queue:", error);
          this.error =
            "An error occurred while fetching update queue details. Please try again later.";
        } finally {
          this.loading = false;
        }
      },
    },
  };
  </script>
  